import Layout from '@layouts/Layout';
import Updates from '@screens/Updates';

import { NextSeoTraqq } from '@components/Seo';

import React, { memo } from 'react';

export const getStaticProps = async () => {

    const isTestEnvironment = process.env.NEXT_PUBLIC_APP_URL === 'https://test.traqq.com';
    const testAuth = isTestEnvironment && process.env.TEST_BASIC_AUTH_USERNAME && process.env.TEST_BASIC_AUTH_PASSWORD
        ? `Basic ${ Buffer.from(`${ process.env.TEST_BASIC_AUTH_USERNAME }:${ process.env.TEST_BASIC_AUTH_PASSWORD }`).toString('base64') }`
        : undefined;

    const post = await (await fetch(`${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/updates`, {
        headers: testAuth ? { Authorization: testAuth } : {}
    })).json();

    return {
        props: { post },
        revalidate: 60 * 60 * 24 // In seconds
    };
};

const UpdatesPage = ({ post }) => (
    <Layout>
        <NextSeoTraqq
            title='Product Updates Traqq'
            description='Check out the latest product updates, releases and integrations. Traqq is always improving to make time tracking even easier!'
            titleTemplate='%s'
            openGraph={ {
                images: [{
                    url: `${ process.env.NEXT_PUBLIC_APP_URL }/og-thumbnail-updates.jpg`,
                    alt: 'Traqq Time Tracker Product Updates'
                }]
            } }
            norobots={ true }
        />

        <Updates
            post={ post }
        />

    </Layout>
);

export default memo(UpdatesPage);
